import React, { Component } from 'react'
import has from 'lodash/has'

import '../../../css/striped-fields.css'

class MerchantSettingsFieldsMoneris extends Component {

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.props.handleFieldSave(event.target.id)
        }
    }

    handleChange(event) {
        event.preventDefault()
        this.props.handleMerchantInputUpdate(event)
    }

    handleKeyPressCountry(event, index) {
        if (event.key === 'Enter') {
            this.props.handleFieldSave(event.target.id)
        }
    }

    handleChangeCountry(event, index) {
        event.preventDefault()
        this.props.handleMerchantInputUpdate(event)
    }

    showButton(id) {
        return <button
            className={'icon-pencil save-item-btn' +
                (this.props.initialMerchantValues[id] !== this.props.merchant[id] ? ' show-edit-button' : '') +
                (this.props.fieldsSaving.indexOf(id) > -1 ? ' loading' : '') +
                (!!this.props.fieldsSuccess.id ? ' icon-checkmark' : '')
            }
            onClick={() => this.props.handleFieldSave(id)}
            disabled={this.props.fieldsSaving.indexOf(id) > -1}
        ></button>
    }

    showCountryButton(id, index) {
        // console.log(this.props.initialMerchantValues.stores[index][id], this.props.merchant.stores[index][id])
        return <button
            className={'icon-pencil save-item-btn' +
                (this.props.initialMerchantValues.stores[index][id] !== this.props.merchant.stores[index][id] ? ' show-edit-button' : '') +
                (this.props.fieldsSaving.indexOf(id) > -1 ? ' loading' : '') +
                (!!this.props.fieldsSuccess[id] ? ' icon-checkmark' : '')
            }
            onClick={() => this.props.handleFieldSave(id)}
            disabled={this.props.fieldsSaving.indexOf(id) > -1}
        ></button>
    }

    showStatus(id) {
        let items = []

        // Show error
        has(this.props.fieldsErrored, id) &&
            items.push(<div key={'error-' + id} className="error msg_animate">{this.props.fieldsErrored[id]}</div>)

        // Show success
        has(this.props.fieldsSuccess, id) &&
            items.push(<div key={'success-' + id} className="success msg_animate">{this.props.fieldsSuccess[id]}</div>)

        return items
    }

    getMerchantPassword(id) {
        let value = this.props.initialMerchantValues[id] ? `••••••••••••••••` : ''
        if (this.props.merchant[id] !== true && this.props.merchant[id] !== false) {
            value = this.props.merchant[id]
        }

        return value
    }

    render() {
        const { merchant } = this.props

        return (
            <div className="moneris-fields" autoComplete="off">
                <div className="fieldset">
                    <label className="title-label">Sandbox Information:</label>

                    <table className="product-prices product-prices--fixed-column">
                        <tbody>
                            <tr className="product-item">
                                <td className="item-title">Store ID</td>
                                <td>
                                    {this.showStatus('store_id_sandbox')}
                                    <input type="text" id="store_id_sandbox" value={merchant.store_id_sandbox} placeholder="store1" maxLength="20" autoComplete="off"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                                <td className="save-cell">
                                    {this.showButton('store_id_sandbox')}
                                </td>
                            </tr>
                            <tr className="product-item">
                                <td className="item-title">API Token</td>
                                <td>
                                    {this.showStatus('api_token_sandbox')}
                                    <input type="password" id="api_token_sandbox" value={this.getMerchantPassword('api_token_sandbox')} placeholder="token" maxLength="100" autoComplete="off"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                                <td className="save-cell">
                                    {this.showButton('api_token_sandbox')}
                                </td>
                            </tr>
                            <tr className="product-item">
                                <td className="item-title">Credit Card Type</td>
                                <td>
                                    {this.showStatus('sandbox_card_type')}
                                    <input type="text" id="sandbox_card_type" value={merchant.sandbox_card_type} placeholder="Visa/Mastercard/etc" maxLength="30"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                                <td className="save-cell">
                                    {this.showButton('sandbox_card_type')}
                                </td>
                            </tr>
                            <tr className="product-item">
                                <td className="item-title">Credit Card Acct</td>
                                <td>
                                    {this.showStatus('merchant_user_sandbox')}
                                    <input type="text" id="sandbox_card_acct" value={merchant.sandbox_card_acct} placeholder="1234123412341234" maxLength="16"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                                <td className="save-cell">
                                    {this.showButton('merchant_user_sandbox')}
                                </td>
                            </tr>
                            <tr className="product-item">
                                <td className="item-title">Credit Card Expiry</td>
                                <td>
                                    {this.showStatus('sandbox_card_expiry')}
                                    <input className="date" type="text" id="sandbox_card_expiry" value={merchant.sandbox_card_expiry} placeholder="201603" maxLength="10"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                                <td className="save-cell">
                                    {this.showButton('sandbox_card_expiry')}
                                </td>
                            </tr>
                            <tr className="product-item">
                                <td className="item-title">Credit Card CVV</td>
                                <td>
                                    {this.showStatus('sandbox_card_cvv')}
                                    <input className="date" type="text" id="sandbox_card_cvv" value={merchant.sandbox_card_cvv} placeholder="123" maxLength="4"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                                <td className="save-cell">
                                    {this.showButton('sandbox_card_cvv')}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="fieldset">
                    <label className="title-label">Live Information:</label>

                    <table className="product-prices product-prices--fixed-column new-country">
                        <tbody>
                            <tr className="product-item">
                                <td className="item-title">Country Code</td>
                                <td>
                                    {this.showStatus('country')}
                                    <input type="text" id="country" value={merchant.country} placeholder="CA" maxLength="2"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr className="product-item">
                                <td className="item-title">Store ID</td>
                                <td>
                                    {this.showStatus('store_id')}
                                    <input type="text" id="store_id" value={merchant.store_id} placeholder="store1" maxLength="50"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr className="product-item">
                                <td className="item-title">API Token</td>
                                <td>
                                    {this.showStatus('api_token')}
                                    <input type="password" id="api_token" value={merchant.api_token} placeholder="token" maxLength="100"
                                        onKeyPress={e => this.handleKeyPress(e)}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2"><button name="add-new-country" className="btn btn--floated-right"><span>Add New</span></button></td>
                            </tr>
                        </tbody>
		            </table>

                    <table className="product-prices product-prices--fixed-column existing-countries">
                            {merchant.stores.map((store, i) => {
                                return (
                                    <tbody key={i}>
                                        <tr className="product-item">
                                            <td className="item-title">Country Code</td>
                                            <td>
                                                <input type="text" name="country" value={store.country} placeholder="CA" maxLength="2"
                                                    onKeyPress={e => this.handleKeyPressCountry(e)}
                                                    onChange={e => this.handleChangeCountry(e, i)}
                                                />
                                            </td>
                                            <td className="save-cell">
                                                {this.showCountryButton('country', i)}
                                            </td>
                                        </tr>
                                        <tr className="product-item">
                                            <td className="item-title">Store ID</td>
                                            <td>
                                                <input type="text" name="store_id" value={store.store_id} placeholder="store1" maxLength="50"
                                                    onKeyPress={e => this.handleKeyPressCountry(e)}
                                                    onChange={e => this.handleChangeCountry(e, i)}
                                                />
                                            </td>
                                            <td className="save-cell">
                                                {this.showCountryButton('store_id', i)}
                                            </td>
                                        </tr>
                                        <tr className="product-item">
                                            <td className="item-title">API Token</td>
                                            <td>
                                                <input type="password" name="api_token" value={store.api_token ? 1 : ''} placeholder="token" maxLength="100"
                                                    onKeyPress={e => this.handleKeyPressCountry(e)}
                                                    onChange={e => this.handleChangeCountry(e, i)}
                                                />
                                            </td>
                                            <td className="save-cell">
                                                {this.showCountryButton('api_token', i)}
                                            </td>
                                        </tr>
                                    </tbody>
                                )
                            })}
                    </table>
                </div>
            </div>
        )
    }
}

export default MerchantSettingsFieldsMoneris



// WEBPACK FOOTER //
// ./src/components/admin/merchant/MerchantSettingsFieldsMoneris.js